<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="pro"><a id="page_vii"></a><a href="#/xhtml/prologue#pro">Prologue</a></p>
<p class="Toca" id="fm"><a href="#/xhtml/illustration#fm">Maps</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">A Posthumous Inauguration</span></a></p>
<p class="Toc" id="ch-002"><a href="#/xhtml/chapter002#ch002">2.<span class="space1">An Inappropriate Question</span></a></p>
<p class="Toc" id="ch-003"><a href="#/xhtml/chapter003#ch003">3.<span class="space1">Young Man Ernst</span></a></p>
<p class="Toc" id="ch-004"><a href="#/xhtml/chapter004#ch004">4.<span class="space1">University Years</span></a></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">The Great War</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">Transplant in Breslau</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Full Bloom in Breslau</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Swastika!</span></span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">The Jewish Question</span></span></p>
<p class="Toc" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.<span class="space05">Battle at Breslau</span></span></p>
<p class="Toc" id="ch-011"><span href="#/xhtml/chapter011#ch011" title="Link target outside of Sample">11.<span class="space05">Ouster</span></span></p>
<p class="Toc" id="ch-012"><a id="page_viii"></a><span href="#/xhtml/chapter012#ch012" title="Link target outside of Sample">12.<span class="space05">Barbarossa</span></span></p>
<p class="Toc" id="ch-013"><span href="#/xhtml/chapter013#ch013" title="Link target outside of Sample">13.<span class="space05">New Beginnings</span></span></p>
<p class="Toc" id="ch-014"><span href="#/xhtml/chapter014#ch014" title="Link target outside of Sample">14.<span class="space05">One against Many</span></span></p>
<p class="Toc" id="ch-015"><span href="#/xhtml/chapter015#ch015" title="Link target outside of Sample">15.<span class="space05">Years of Silence</span></span></p>
<p class="Toc" id="ch-016"><span href="#/xhtml/chapter016#ch016" title="Link target outside of Sample">16.<span class="space05">Return to the Posthumous Inauguration</span></span></p>
<p class="Toc" id="ch-017"><span href="#/xhtml/chapter017#ch017" title="Link target outside of Sample">17.<span class="space05">The Last Letter</span></span></p>
<p class="Tocb" id="abb"><span href="#/xhtml/abbreviations#abb" title="Link target outside of Sample">Abbreviations</span></p>
<p class="Toca" id="note"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="Toca" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toca" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2390a5d1